import { computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { settingsRepo } from "@/di/repositories";

export function useApproaches() {
  const { data, isPending } = useQuery({
    queryKey: ["settings", "approaches"],
    queryFn: () => settingsRepo.getApproaches(),
    staleTime: Infinity,
  });
  return { approaches: computed(() => data.value ?? []), isPending };
}

export function useOccupationAreas() {
  const { data, isPending } = useQuery({
    queryKey: ["settings", "occupation-areas"],
    queryFn: () => settingsRepo.getOccupationAreas(),
    staleTime: Infinity,
  });
  return { occupationAreas: computed(() => data.value ?? []), isPending };
}

export function useLanguages() {
  const { data, isPending } = useQuery({
    queryKey: ["settings", "languages"],
    queryFn: () => settingsRepo.getLanguages(),
    staleTime: Infinity,
  });
  return { languages: computed(() => data.value ?? []), isPending };
}
